import { render, staticRenderFns } from "./Instructions2023.vue?vue&type=template&id=5a5c0836&scoped=true"
import script from "./Instructions2023.vue?vue&type=script&lang=js"
export * from "./Instructions2023.vue?vue&type=script&lang=js"
import style0 from "./Instructions2023.vue?vue&type=style&index=0&id=5a5c0836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c0836",
  null
  
)

export default component.exports